// @flow
export const theme = {
  bg: {
    default: "#FFFFFF",
    reverse: "#16171A",
    alt: "#f1f1f1",
    light: "#f9f9f9",
    border: "#EBECED"
  },
  brand: {
    default: "#4a8af3",
    alt: "#666666"
  },
  generic: {
    default: "#E6ECF7",
    alt: "#F6FBFC"
  },
  social: {
    facebook: {
      default: "#3B5998",
      alt: "#5A85DF"
    },
    twitter: {
      default: "#00ACED",
      alt: "#53D0FF"
    },
    google: {
      default: "#ea4335",
      alt: "#ea4335"
    }
  },
  text: {
    default: "#1d1d1f",
    secondary: "#384047",
    alt: "#67717A",
    placeholder: "#7C8894",
    reverse: "#FFFFFF"
  }
}

export default theme
